import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AdminLayout from './AdminLayout';
import WorkflowSchedule from './WorkflowSchedule';

// One workflow's Big Picture schedule on its own page, reached from the 📅 pill on
// that workflow's board (Pat, Sep 24 2026 — Loops first). Same List / Calendar as the
// Big Picture's second table, held to this one workflow.
const PAGES = {
  loops:               { label: 'Loops',               icon: '🔁' },
  vertical_drilling:   { label: 'Vertical Drilling',   icon: '🕳️' },
  horizontal_drilling: { label: 'Directional Drilling', icon: '↔️' },
  small_jobs:          { label: 'Small Jobs',          icon: '🗂️' },
};

export default function WorkflowSchedulePage() {
  const navigate = useNavigate();
  const { type } = useParams();
  const page = PAGES[type];
  const back = () => navigate(`/admin/workflows/${type}`);
  return (
    <AdminLayout>
      {!page ? (
        <div style={{ padding: 30, color: '#6b7280' }}>There is no schedule page for that workflow.</div>
      ) : (
        <WorkflowSchedule fixedType={type} header={<>
          <button onClick={back} style={{ fontSize: 12.5, padding: '6px 10px', borderRadius: 8, border: '1px solid var(--border)', background: 'var(--surface)', color: 'var(--text)', cursor: 'pointer', fontWeight: 700 }}>‹ {page.label}</button>
          <h1 style={{ fontSize: 21, fontWeight: 800, margin: 0 }}>{page.icon} {page.label} Schedule</h1>
        </>} />
      )}
    </AdminLayout>
  );
}
